    import { Mapper } from "../../../../base/utils/mapper";
    import { TypeTransferPhysiotherapyModel } from "../../../../domain/models/consult/type-transfer-physiotherapy.model";
    import { TypeTransferPhysiotherapyEntity } from "../entities/type-transfer-physiotherapy.entity";
    export class TypeTransferPhysiotherapyImplementationRepositoryMapper extends Mapper<TypeTransferPhysiotherapyEntity, TypeTransferPhysiotherapyModel>{
            mapFrom(param:  TypeTransferPhysiotherapyEntity):  TypeTransferPhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  TypeTransferPhysiotherapyModel):  TypeTransferPhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }